import React from "react";
import LoginForm from "./LoginForm";

function LoginPage() {
  return <LoginForm />;
}

export default LoginPage;
